/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_User_Menu_Sign_OutInputs */

const en_layout_user_menu_sign_out = /** @type {(inputs: Layout_User_Menu_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const pl_layout_user_menu_sign_out = /** @type {(inputs: Layout_User_Menu_Sign_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

/**
* | output |
* | --- |
* | "Log out" |
*
* @param {Layout_User_Menu_Sign_OutInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_user_menu_sign_out = /** @type {((inputs?: Layout_User_Menu_Sign_OutInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_User_Menu_Sign_OutInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_user_menu_sign_out(inputs)
	return en_layout_user_menu_sign_out(inputs)
});